<template>
  <div class="">
    <el-button size="mini" type="primary" @click="exportTable"
      >导出报表</el-button
    >
  </div>
</template>
<script>
export default {
  name: "exporter",
  props: {
    setting: Object,
    url: String,
    date: Array,
    postParams: Object,
    exportName: String,
    reportType:String
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App"
    };
  },
  methods: {
    exportTable: function() {
      console.log(this.setting, "====");
      console.log(this.postParams, "++++++");
      var list = [];
      var set = this.setting;
      var postParams = this.postParams;
      var url = this.url;
      var thArr = [];
      var filterArr = [];
      for (var i = 0; i < set.tHeader.length; i++) {
        var temp = set.tHeader[i];
        thArr.push(temp.dataName); // 大区...
        filterArr.push(temp.dataItem); // 英文...
      }
      let params = {

      };
      if (this.date != undefined) {
        params.startDay = this.date[0];
        params.endDay = this.date[1];
      }

      if (typeof set.status == "number") {
        params.status = set.status;
      }
      if (set.goodsNum) {
        params.goodsNum = set.goodsNum;
      }
      if (set.assetsNum) {
        params.assetsNum = set.assetsNum;
      }

      if (set.groupType) {
        params.groupByParam = set.groupType;
      }
      if(set.groupName) {
        params.groupName = set.groupName
      }
      if (postParams != undefined) {
          //console.log(postParams,"-=======================================");
        // 1为大区销售报表 2为渠道销售报表 3
        if (this.reportType) {
          params.reportType = this.reportType;
        }

        for (let k in postParams) {
        if (postParams[k] != "") params[k] = postParams[k];
      }



        // if (postParams.groupId) {
        //   params.groupId = postParams.groupId;
        // }
        // if (postParams.assetsNum) {
        //   params.assetsNum = postParams.assetsNum;
        // }
        // if (postParams.channelType) {
        //   params.channelType = postParams.channelType;
        // }
        // if (postParams.secondChannelType) {
        //   params.secondChannelType = postParams.secondChannelType;
        // }
        // if (postParams.thirdChannelType) {
        //   params.thirdChannelType = postParams.thirdChannelType;
        // }
        // if (postParams.keyWord) {
        //   params.keyWord = postParams.keyWord;
        // }
      }
      params.pageSize=99999;

      params.pageNum=1;
      let _this = this;
      let exportName = "";
      if (this.exportName != undefined) {
        exportName = this.exportName;
        if (set.goodsNum) {
          exportName += "_" + set.goodsName;
        } else if (set.assetsNum) {
          exportName += "_" + set.assetsNum;
        }
        if (this.date != undefined) {
          exportName += "_" + this.date[0] + "至" + this.date[1];
        }
      } else {
        exportName = "报表";
      }

      this.$ajax
        .post(url, params)

        .then(function(res) {
          if (res.data && res.data.code === 200) {
            const data = res.data.data;
            if (data.tableList) {
              list = data.tableList.list;
            } else {
              list = data.list;
            }
            if (url === 'data/getDataReport_AssetsList') {
              list.forEach((item, index) => {
                let onlineStatus = item.onlineStatus
                switch (onlineStatus) {
                  case 0:
                    item.onlineStatus = '离线'
                    break;
                  // eslint-disable-next-line no-fallthrough
                  case 1:
                    item.onlineStatus = '在线'
                    break;
                  default:
                    break;
                }
              })
            }
            require.ensure([], () => {
              const {
                export_json_to_excel
              } = require("../vendor/Export2Excel");
              const tHeader = thArr;
              const filterVal = filterArr;
              const data = _this.formatJson(filterVal, list);
              export_json_to_excel(tHeader, data, exportName);
            });
          } else {
            let errMsg = "未知错误";
            if (res.data.msg) {
              errMsg = res.data.msg;
            }
            _this.$message.error(errMsg);
          }
        })
        .catch(function(res) {
          _this.$message.error("哎呀~网络异常了呢");
        });
    },
    formatJson: function(filterVal, jsonData) {
      console.log(filterVal, "0000");
      console.log(jsonData, "111");
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/exporter.vue